import React from 'react'
import { SelectAsync } from '@arnsbogroup/react-voicearchive'
import debounce from 'debounce-promise'
import { FormattedMessage, useIntl } from "react-intl";
import messages from "./messages";

const AccentsAndDialects = ({ supplier, onChangeHandler }) => {
    const { formatMessage } = useIntl()

    const handleChange = (languageId, selectedOptions, key) => {
        const updatedLanguage = supplier.languages.map((language) => {
            if (language.uid == languageId) {
                language[key] = selectedOptions && !!selectedOptions.length ? selectedOptions?.map((option) => ({ id: option.value, name: option.label })) : []
            }
            return language
        })

        onChangeHandler({ ...supplier, languages: updatedLanguage })
    }

    return (
        <div className="w-full">
            <div className='flex w-full gap-6 my-4'>
                <div className='w-1/2'>
                    <div>
                        <label className="text-gray-700">
                            <FormattedMessage {...messages.dialectTitle} />
                        </label>
                    </div>
                    <div >
                        <label className="text-gray-700 font-normal text-xs">
                            <FormattedMessage {...messages.dialectDescription} />
                        </label>
                    </div>
                </div>
                <div className='w-1/2'>
                    <div>
                        <label className="text-gray-700">
                            <FormattedMessage {...messages.accentTitle} />
                        </label>
                    </div>
                    <div>
                        <label className="text-gray-700 font-normal text-xs">
                            <FormattedMessage {...messages.accentDescription} />
                        </label>
                    </div>
                </div>
            </div>
            {supplier.languages.map(({ accents, dialects, uid, name }) => (
                <div className='flex w-full gap-6'>
                    <div key={uid} className="flex items-center mb-4 w-full">
                        <label className="text-gray-700 text-sm w-1/4">{name}</label>
                        <div className="grow">
                            <SelectAsync
                                value={!!dialects.length ? dialects.map((dialect) => ({ label: dialect.name, value: dialect.id })) : null}
                                onChange={(data) => handleChange(uid, data, 'dialects')}
                                cacheOptions
                                loadOptions={debounce((query) =>
                                fetch(`/rest/v2/dialect?pageSize=25&search[name]=${query}&search[language_uid]=${uid}`)
                                    .then((response) => response.json())
                                    .then((results) => results.map(({ uid, name }) => ({ label: name, value: +uid })))
                                , 250)}
                                placeholder={formatMessage(messages.dialectSelectPlaceholder)}
                                isClearable
                                isMulti
                                defaultOptions
                                className="w-full"
                            />
                        </div>
                    </div>
                    <div key={uid} className="flex items-center mb-4 w-full">
                        <label className="text-gray-700 text-sm w-1/4">{name}</label>
                        <div className="grow">
                            <SelectAsync
                                value={!!accents.length ? accents.map((accent) => ({ label: accent.name, value: accent.id })) : null}
                                onChange={(data) => handleChange(uid, data, 'accents')}
                                cacheOptions
                                loadOptions={debounce((query) =>
                                fetch(`/rest/v2/language?pageSize=25&search[name]=${query}`)
                                    .then((response) => response.json())
                                    .then((results) => results.map(({ uid, name }) => ({ label: name, value: +uid })))
                                , 250)}
                                placeholder={formatMessage(messages.accentSelectPlaceholder)}
                                isClearable
                                isMulti
                                defaultOptions
                                className="w-full"
                            />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default AccentsAndDialects
